module.exports = __webpack_public_path__ + "img/icb-empty-Adv-m@2x.93fe254c.png";